import React, {useState , useEffect , useContext} from 'react'
import {  useNavigate, useSearchParams } from "react-router-dom"
import axios from "axios";
import {Helmet} from 'react-helmet'
import { login } from './../../Redux/features/authSlice'
import { updateGeneralUI } from '../../Redux/features/uiReducer'
import { useSelector, useDispatch } from 'react-redux'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { Main , Input, Checkbox, Button } from '../../Components';
import { Card } from '../../Components/Card/Card';

import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

import './login.css'
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import moment from 'moment'
import {MdOutlineMarkEmailUnread} from 'react-icons/md'
/**
 * 
 * @returns 
 */
export function Login() {

    const [searchParams] = useSearchParams();
	const [formData, setFormData] = useState({
		email: "",
		password: "",
		 
	});

	const [isLoading, setIsLoading] = useState(false)
	const [sessionToken, setSessionToken] = useState(null)
    const [loginStep, setLoginStep] = useState('email')

	const { email, password } = formData;

	const navigate = useNavigate();
	const dispatch = useDispatch();

	
	// Grab the data from redux 
	const { user } = useSelector((state) => state.auth);

    

	 

	useEffect(() => {
        //console.log('useEffect start');
        
		async function fetchData() {
            // You can await here
			await verifySession()
			.then(token => {
				setSessionToken(token)
				
                
			})
			.catch(err => {
                
				
			});
			// ...
		}
		fetchData();
	
	   
	}, [])


	useEffect(() => {
		if(sessionToken !== null && user ){
			navigate(`/`);
		}
	}, [sessionToken])

    /**
     * 
     * @returns 
     */
    const  verifySession = () =>  {

        return new Promise(async (resolve, reject) => {
            
             
            if (user && user.token) {
                
                const { token } = user;
                //console.log(token);
                // Verify token
                await axios
                    .post(`${process.env.REACT_APP_API_URL}/users/session/verify`, { 
                        token : token 
    
                    })
                    .then(res => res.data )
                    .then(res => {
    
                        const expiredTime = res.exp;
                        if(moment().diff(moment(expiredTime*1000) , 'minutes') < 0 ){
                            resolve(token)
                        }else{
    
                            reject({
                                error : 'expired_session'
                            })
                        }
                         
                     
                    })
                    .catch(err => {
                        reject({
                            error : err
                        });
                    })
            } else {
                reject({
                    error: "no_token"
                })
             
            }
        });

    }
	

	const onChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const onSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true) 

        // STEP 1 : Check the email address 
        if(loginStep === 'email'){
            await axios
			.post(`${process.env.REACT_APP_API_URL}/users/login/email`, {
                email : email
            } , {} )
			.then(res => res.data )
			.then(async response => {
                if(response?.login_method === 'default'){
                    setLoginStep('password')
                }else if (response?.login_method === 'magic-link'){

                    setLoginStep('magic-link')
                }
                setIsLoading(false)
            })
            .catch( error => {
                if (error.response) {
					toast.error(error.response.data.message) 
					 
					setIsLoading(false)
					
				} else {
					// Something happened in setting up the request that triggered an Error
					if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
						toast.error("An error occurred while logging into your account, please try again later") 
                    }
                    setIsLoading(false)
				} 
            })
            


        }else if (loginStep === 'password'){

            let userData = {
                email,
                password,
            };
    
            const invitationId = searchParams.get('invitationid')
            if(typeof invitationId!=='undefined' && invitationId!==null && invitationId!=='' ) userData.inviteId = invitationId;
    
            await axios
                .post(`${process.env.REACT_APP_API_URL}/users/login`, userData , {} )
                .then(res => res.data )
                .then(async response => {
    
                    if (typeof response?.token !== 'undefined' && response?.token !== null) {
                        
                        // save token as session in localStorage 
                        // localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_USER, JSON.stringify(response))
                        // localStorage.setItem(process.env.REACT_APP_STORAGE_AUTH_ORG, JSON.stringify(response.organizations.find(x => x.is_default === true) ?? response.organizations[0]))
                         
                        dispatch(login(response));
                        dispatch(updateGeneralUI({
                            show_sidebar : true
                        }))
                         
                        setSessionToken(response?.token)
    
                        setIsLoading(false)
                        
    
    
                        
                    } else {
                        
                        toast.error("Something went wrong. Thank you try later.") 
    
                        setIsLoading(false)
                        
                    }
                })
                .catch(error => {
    
                    //console.log('error : ' , error);
                    if (error.response) {
                        // The request was made and the server responded with a status code
                         
                        ////console.log(error.response.data);
                        ////console.log(error.response.status);
                        ////console.log(error.response.headers);
                        
                         
                        toast.error(error.response.data.message) 
                         
                        setIsLoading(false)
                        
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
                             
                            
                            toast.error("An error occurred while logging into your account, please try again later") 
                            
                            
                        }
                        setIsLoading(false)
                    } 
                })
        }




		
	};

 

	return (
		<>
		<Helmet>
			<title>Login - {process.env.REACT_APP_APP_NAME}</title>
		</Helmet>
		<Main size={`full`} withNav={false} positionY="top"  >
			<div className="layout-login-form">
				<div className="logo-wrapper">
					<Logo />
				</div> 
				<Card shadow="md" target="login">
                    {
                        loginStep === 'magic-link'
                        ? <div className="" >
                            <div className="magic-link__email-icon"><MdOutlineMarkEmailUnread /></div>
                            <div className="title">Check you email</div>
                            <div className="main-info">We've sent a magic link to your email address. Please check your inbox and click on the link to log in.</div>
                            <p>If you don't see the email, please check your spam folder. If you still can't find it, you can try resending the magic link by entering your email again.</p>

                        </div>
                        : <form onSubmit={onSubmit}>
                            <div className='title'>Log in </div>
                            <Input 
                                type="email"
                                name="email"
                                label="Email"
                                placeholder="your@domain.com"
                                required
                                onChange={onChange}
                                />
                            {
                                loginStep === 'password' &&   
                                <Input 
                                    type="password" 
                                    name="password" 
                                    label="Password" 
                                    placeholder="Your password" 
                                    required  
                                    onChange={onChange}/>
                            }
                            <div>
                                {/* <Checkbox 
                                    name="reminder_me"
                                    label="Remember me"
                                    onChange={(e) => setFormData((prevState) => ({
                                        ...prevState,
                                        reminder_me : e.target.checked
                                    }))}
                                    /> */}
                                <Link  to="/forgot-password" >
                                    Forgot password?
                                </Link>
                            </div>
                            <div className="field-group submit-fields-group fluid">
                                <Button onClick={onSubmit} loading={isLoading} color="purple" >Sign in</Button>
                            </div>
                        </form>
                    }
					

				</Card>
                <div className='under-form'>Don't have an account? <Link to={`/registration${searchParams.get('invitationid')!==null ? `?invitationid=${searchParams.get('invitationid')}` : ''}`}>Sign up</Link></div>
                {
                    loginStep !=='email' && 
                    <div className='under-form link' onClick={()=> { setLoginStep('email') }}>Back to login</div>
                }
			</div>
		</Main>
		</>
	)
}

 